// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafica-banche/stats',
    requestBody: null,
    response: '{"success":"boolean","data":{"nBanche":"number","nSportelli":"number","ultimoAggiornamento":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafica-banche?q=',
    requestBody: null,
    response: '{"success":"boolean","data":"Banca[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafica-banche/sportelli?q=&limit=',
    requestBody: null,
    response: '{"success":"boolean","data":"Sportello[]"}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafica-banche/aggiorna',
    requestBody: null,
    response: '{"success":"boolean","data":{"banche":"number","sportelli":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafica-banche/banca',
    requestBody: '{"abi":"string","denominazione":"string"}',
    response: '{"success":"boolean","data":"Banca"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafica-banche/banca/:abi',
    requestBody: '{"denominazione":"string"}',
    response: '{"success":"boolean"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafica-banche/banca/:abi',
    requestBody: null,
    response: '{"success":"boolean"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
